import { useMemo } from "react";
import { useParams } from "react-router-dom";
import queryString from "query-string";

const __getKVSession = function () {
  if (!window) {
    return null;
  }

  const kvSession = window.localStorage.getItem("kvSession");
  if (!kvSession) {
    return null;
  }

  const kvSessionJson = JSON.parse(kvSession);

  return kvSessionJson;
};

export function useRouter() {
  const params = useParams();
  // Return our custom router object
  // Memoize so that a new object is only returned if something changes
  return useMemo(() => {
    if (localStorage && localStorage.getItem("isWidgetMykiot")) {
      // get session
      const kvSession = __getKVSession();

      return {
        query: {
          id: "",
          color: "",
          code_theme: "",
          name: "",
          disableApply: "",
          namespace: "",
          code: kvSession && kvSession.BearerToken,
          platform: "retail",
          preview: "",
          preview_primary: "",
          preview_secondary: "",
          website_url: "",
          mode: "",
          layout: "",
          "*": "",
          ref_code: "",
          ref_id: "",
          domain: "",
          is_old: "",
          fr: "",
          template_id: "",
          access_token: "",
          merchantId: "",
          openPopup: "",
          branchId: "",
          is_sample: "",
          domainType: "",
          step: "",
          active_tab: "",
          lang: "",
          language: "",
          scrollTo: "",
          show_left_menu: "",
          is_keivi: "",
          is_reload: "",
          onboarding_type: "",
          onboarding_fnb_click: "",
          page_builder_keivi_region: "",
          pos_version: "",
          pos_app: "",
        },
      };
    }

    return {
      // pathname: location.pathname,
      // Merge params and parsed query string into single "query" object
      // so that they can be used interchangeably.
      // Example: /:topic?sort=popular -> { topic: "react", sort: "popular" }
      query: {
        // Convert string to object
        ...queryString.parse(window.location.search),
        ...params,
      },
    };
  }, [params]);
}
